// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Util_I18n = require("../util/Util_I18n.bs.js");
var Type_String = require("./Type_String.bs.js");

function keyToString(key) {
  switch (key) {
    case /* Disconnect */0 :
        return "Disconnect";
    case /* Events */1 :
        return "Events";
    case /* EventsFavorite */2 :
        return "EventsFavorite";
    case /* Mona */3 :
        return "Mona";
    case /* Magazine */4 :
        return "Magazine";
    case /* MyAccount */5 :
        return "MyAccount";
    case /* Password */6 :
        return "Password";
    case /* Profile */7 :
        return "Profile";
    case /* TvConnection */8 :
        return "TvConnection";
    
  }
}

function isCurrentKey(key, currentKey) {
  if (key === currentKey) {
    return /* Current */0;
  } else {
    return /* Default */1;
  }
}

function profileLinkState(currentKey) {
  switch (currentKey) {
    case /* Events */1 :
    case /* EventsFavorite */2 :
    case /* Magazine */4 :
        return /* Default */1;
    case /* Disconnect */0 :
    case /* Mona */3 :
    case /* MyAccount */5 :
    case /* Password */6 :
    case /* Profile */7 :
    case /* TvConnection */8 :
        return /* Current */0;
    
  }
}

function makeHref(locale, subroute) {
  return "/" + Util_I18n.localeToString(locale) + "/profile/" + (
          subroute !== undefined ? subroute : ""
        );
}

function makeItems(labels, currentKey, onLogoutCallback, locale) {
  var match = labels.mona.navigation;
  var makeHrefFromKey = function (key) {
    var tmp;
    switch (key) {
      case /* Disconnect */0 :
      case /* Events */1 :
      case /* EventsFavorite */2 :
      case /* Mona */3 :
      case /* Magazine */4 :
      case /* MyAccount */5 :
          tmp = makeHref(locale, undefined);
          break;
      case /* Password */6 :
          tmp = makeHref(locale, "password");
          break;
      case /* Profile */7 :
          tmp = makeHref(locale, "profile");
          break;
      case /* TvConnection */8 :
          tmp = makeHref(locale, "tvlogin");
          break;
      
    }
    return Curry._1(Type_String.Href.make, tmp);
  };
  return [
          {
            TAG: /* Link */0,
            _0: {
              key: /* MyAccount */5,
              label: match.myAccount,
              href: makeHrefFromKey(/* MyAccount */5),
              state: isCurrentKey(/* MyAccount */5, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* Password */6,
              label: match.password,
              href: makeHrefFromKey(/* Password */6),
              state: isCurrentKey(/* Password */6, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* Profile */7,
              label: match.profile,
              href: makeHrefFromKey(/* Profile */7),
              state: isCurrentKey(/* Profile */7, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* TvConnection */8,
              label: match.tvConnection,
              href: makeHrefFromKey(/* TvConnection */8),
              state: isCurrentKey(/* TvConnection */8, currentKey)
            }
          },
          {
            TAG: /* Button */1,
            _0: {
              key: /* Disconnect */0,
              label: match.disconnect,
              action: /* Logout */{
                _0: onLogoutCallback
              }
            }
          }
        ];
}

var Profile = {
  makeHref: makeHref,
  makeItems: makeItems
};

function makeItems$1(labels, currentKey, locale) {
  var match = labels.mona.navigation;
  var myArteBaseUrl = "https://my.arte.tv/index.php?lang=" + Util_I18n.localeToString(locale);
  return [
          {
            TAG: /* Link */0,
            _0: {
              key: /* Mona */3,
              label: match.mona,
              href: Curry._1(Type_String.Href.make, myArteBaseUrl),
              state: isCurrentKey(/* Mona */3, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* Events */1,
              label: match.events,
              href: Curry._1(Type_String.Href.make, myArteBaseUrl + "&page=events"),
              state: isCurrentKey(/* Events */1, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* EventsFavorite */2,
              label: match.eventsFavorite,
              href: Curry._1(Type_String.Href.make, myArteBaseUrl + "&page=eventsFavorite"),
              state: isCurrentKey(/* EventsFavorite */2, currentKey)
            }
          },
          {
            TAG: /* Link */0,
            _0: {
              key: /* Magazine */4,
              label: match.magazine,
              href: Curry._1(Type_String.Href.make, "/arte-magazine"),
              state: isCurrentKey(/* Magazine */4, currentKey)
            }
          }
        ];
}

function makeItemsSecondary(labels, currentKey, onLogoutCallback, locale) {
  var match = labels.mona.navigation;
  return [
          {
            TAG: /* Link */0,
            _0: {
              key: /* Profile */7,
              label: match.profile,
              href: Curry._1(Type_String.Href.make, "/" + Util_I18n.localeToString(locale) + "/profile"),
              state: profileLinkState(currentKey)
            }
          },
          {
            TAG: /* Button */1,
            _0: {
              key: /* Disconnect */0,
              label: match.disconnect,
              action: /* Logout */{
                _0: onLogoutCallback
              }
            }
          }
        ];
}

var Header = {
  makeItems: makeItems$1,
  makeItemsSecondary: makeItemsSecondary
};

exports.keyToString = keyToString;
exports.isCurrentKey = isCurrentKey;
exports.profileLinkState = profileLinkState;
exports.Profile = Profile;
exports.Header = Header;
/* No side effect */
